var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fullcalendar-nowrap",style:(_vm.view.type != 'listMonth' && _vm.appSkin != 'dark'
      ? { color: _vm.event.textColor }
      : '')},[_vm._v(" "+_vm._s(_vm.event.extendedProps.materia)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }